<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :name="name"
  >
    <vue-editor
      :editor-toolbar="customToolbar"
      :value="value"
      @input="handleInputValue" />
  </form-section>
</template>

<script>
import { VueEditor } from 'vue2-editor' // https://github.com/davidroyer/vue2-editor
import InputCommon from './InputCommon'
export default {
  name: 'EditorInput',
  mixins: [InputCommon],
  components: {
    VueEditor
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }],
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link']
      ]
    }
  },
  methods: {
    handleInputValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="sass">
@import '~styles/forms/mixins'

.text-area-input__input
  @extend %form-text-input-style
  line-height: 1.5
  min-height: rem-calc(164)
  padding-bottom: rem-calc(20)
  padding-top: rem-calc(20)

</style>



// WEBPACK FOOTER //
// src/components/forms/EditorInput.vue